import React from 'react';
import SelectIndex from '../../form/selec-address/index';
import { getProvinces } from './data';
import model from '../../assets/model';

class Province extends React.Component {
    state = {
        options: []
    }

    componentDidUpdate(prevProps) {

        // 当国家改变时，获取对应的省份列表
        let { countryId, cascade_parent_api_name } = this.props;
        // 检查 countryId 和 cascade_parent_api_name 是否有效
        if (countryId && cascade_parent_api_name && countryId[cascade_parent_api_name] && ((prevProps.countryId == null && countryId[cascade_parent_api_name]) || countryId[cascade_parent_api_name] !== prevProps.countryId[cascade_parent_api_name])) {
            getProvinces({ parentPath: countryId[cascade_parent_api_name], cardId: model.cardId }, (data) => {
                this.setState({ options: data.optionList });
            });
        }
    }
    componentDidMount() {
        //当有默认值时，需要获取省份数据
        let {default_value = undefined, parent_node,api_name
        } = this.props
        if(parent_node && parent_node.default_value){
            getProvinces({ parentPath: parent_node.default_value, cardId: model.cardId }, (data) => {
                this.setState({ options: data.optionList });
            });
            this.props.form.setFieldsValue({
                // 使用 api_name 设置值
                [api_name]: default_value
            });
        }
    }
    render() {

        return (
            <SelectIndex 
                {...this.props} 
                options={this.state.options}
                onChange={this.props.onProvinceChange}
            />
        );
    }
}

export default Province;


// WEBPACK FOOTER //
// ./src/component/Address/Province.js